import React, { useState, useEffect, useRef } from "react"; 
import { Link, useNavigate } from "react-router-dom";
 
const Navbar = () => {
  const [isCollapsed, setIsCollapsed] = useState(true);
  const [showMegaMenu, setShowMegaMenu] = useState(false);
  const [courses, setCourses] = useState([]);
  const [filterType, setFilterType] = useState(["goal", "topic"]);
  const [activeCourseId, setActiveCourseId] = useState(null);
  const [megaMenuPos, setMegaMenuPos] = useState({ left: 0 });
 
  const coursesRef = useRef(null);
  const navigate = useNavigate();

  const toggleNavbar = () => setIsCollapsed((prev) => !prev);

  const updateMegaMenuPosition = () => {
    if (coursesRef.current) {
      const rect = coursesRef.current.getBoundingClientRect();
      const menuWidth = 1100;
      const left = Math.min(
        Math.max(10, rect.left + rect.width / 2 - menuWidth / 2),
        window.innerWidth - menuWidth - 10
      );
      setMegaMenuPos({ left });
    }
  };
 
  useEffect(() => {
    if (showMegaMenu) updateMegaMenuPosition();
    const handleResize = () => updateMegaMenuPosition();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [showMegaMenu]);
 
  useEffect(() => {
    const handleClickOutside = (e) => {
      const menu = document.querySelector(".mega-menu");
      if (
        coursesRef.current &&
        !coursesRef.current.contains(e.target) &&
        (!menu || !menu.contains(e.target))
      ) {
        resetMegaMenu();
      }
    };
 
    if (showMegaMenu) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showMegaMenu]);
 
  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const [goalRes, topicRes] = await Promise.all([
          fetch(`https://api.dikshasea.in/api/courses/type/goal`),
          fetch(`https://api.dikshasea.in/api/courses/type/topic`)
        ]);
 
        if (!goalRes.ok || !topicRes.ok) throw new Error("Network error");
 
        const goalData = await goalRes.json();
        const topicData = await topicRes.json();
 
        const combined = [
          ...goalData.map(c => ({ ...c, type: "goal" })),
          ...topicData.map(c => ({ ...c, type: "topic" }))
        ];
 
        setCourses(combined);
      } catch (err) {
        console.error("Failed to fetch courses:", err);
        setCourses([]);
      }
    };
 
    fetchCourses();
  }, []);
 
  useEffect(() => {
    if (showMegaMenu && courses.length > 0 && !activeCourseId) {
      const firstGoalCourse = courses.find(c => c.type === "goal");
      if (firstGoalCourse) {
        setActiveCourseId(firstGoalCourse.id);
      } else if (courses.length > 0) {
        setActiveCourseId(courses[0].id);
      }
    }
  }, [showMegaMenu, courses, activeCourseId]);
 
  const resetMegaMenu = () => {
    setShowMegaMenu(false);
    setActiveCourseId(null);
  };
 
  const handleAccordionClick = (type) => {
    setFilterType(prev =>
      prev.includes(type)
        ? prev.filter(t => t !== type)
        : [...prev, type]
    );
  };
 
 const handleAllCoursesClick = () => {
  resetMegaMenu();
  setIsCollapsed(true);
  navigate("/courses");
};
const handleContactClick = () => {
  resetMegaMenu();
  setIsCollapsed(true);
  navigate("/contact");
};

  const handleCourseClick = (e, courseId) => {
    e.stopPropagation();
    setActiveCourseId(courseId);
  };
 
  // const handleNavLinkClick = () => {
  //   setIsCollapsed(true);
  //   resetMegaMenu();
  // };
  const handleNavLinkClick = () => {
  setIsCollapsed(true); // Collapse mobile menu
  setShowMegaMenu(false); // Close mega menu
};

 
  const activeCourse = courses.find(c => c.id === activeCourseId);
 
  return (
    <nav
      className="navbar navbar-expand-lg bg-white navbar-light shadow sticky-top p-0"
      style={{ position: "fixed", top: 0, left: 0, right: 0, zIndex: 1100 }}
    >
      <Link 
        to="/" 
        className="navbar-brand d-flex align-items-center px-4 px-lg-5"
        onClick={handleNavLinkClick}
      >
        <img src="/img/logo.png" alt="Logo" style={{ height: 60, objectFit: "contain" }} />
      </Link>
 
      <button
        type="button"
        className="navbar-toggler me-4"
        onClick={toggleNavbar}
        aria-label="Toggle navigation menu"
        aria-expanded={!isCollapsed}
      >
        <span className="navbar-toggler-icon" />
      </button>
 
      <div className={`collapse navbar-collapse ${isCollapsed ? "show" : ""}`} id="navbarCollapse">
        <div className="navbar-nav mx-auto p-2 p-lg-0">
          <Link 
            to="/" 
            className="nav-item nav-link"
            onClick={handleNavLinkClick}
          >
            Home
          </Link>
          <Link 
            to="/about" 
            className="nav-item nav-link"
            onClick={handleNavLinkClick}
          >
            About
          </Link>
 
          <div
            className="nav-item nav-link position-relative"
            ref={coursesRef}
            onMouseEnter={() => setShowMegaMenu(true)}
            // onFocus={() => setShowMegaMenu(true)}
            // onClick={() => setShowMegaMenu(true)}
            style={{ cursor: "pointer", paddingLeft: 0 }}
            tabIndex={0}
          >
            <Link 
              to="/courses" 
              style={{ fontWeight: 500, fontSize: 16, color: "rgba(75, 73, 73, 0.7)" }} 
              tabIndex={-1}
              onClick={(e) => {
                e.stopPropagation();
                handleNavLinkClick();
              }}
            >
              Courses
            </Link>
            {showMegaMenu && (
              <div
                className="mega-menu bg-white shadow-lg d-flex"
                style={{
                  position: "fixed",
                  top: 68,
                  left: megaMenuPos.left,
                  width: 1100,
                  height: "calc(100vh - 68px)",
                  zIndex: 1050,
                  border: "1px solid #eee",
                  borderRadius: 10,
                  marginLeft:"4rem",
                  overflow: "hidden"
                }}
              >
                {/* Left Panel */}
                <div style={{ width: 300, background: "#f8f9fa", padding: 15, borderRight: "1px solid #eee", overflowY: "auto" }}>
                  {["goal", "topic"].map((type) => (
                    <div key={type}>
                      <button
                      className={`btn btn-sm w-100 text-start ${filterType.includes(type) ? "btn-outline-dark" : "btn-light"}`}
                      onClick={() => handleAccordionClick(type)}
                      type="button"
                      style={{ border: "none", boxShadow: "none" }}
                    >

                        {type === "goal" ? "🎯 By Goal" : "📚 By Topic"}
                        <i className={`fa ${filterType.includes(type) ? "fa-caret-down" : "fa-caret-right"}`} style={{ float: "right" }} />
                      </button>
 
                      {filterType.includes(type) && (
                        <div style={{ marginTop: 6, background: "#fff", padding: "8px 10px", borderRadius: 6 }}>
                          {courses.filter(c => c.type === type).map(course => (
                            <div
                              key={course.id}
                              className={`course-item ${activeCourseId === course.id ? "active" : ""}`}
                              onClick={(e) => handleCourseClick(e, course.id)}
                              tabIndex={0}
                            >
                              {course.icons?.endsWith(".png") ? (
                                <img src={course.icons.replace(/\\/g, "/")} alt={course.coursename} className="course-icon" />
                              ) : (
                                <i className={`fa ${course.icons || "fa-book"} course-icon`} />
                              )}
                              <span>{course.coursename}</span>
                            </div>
                          ))}
                          {type === "goal" && (
                            <div
                              className={`course-item ${activeCourseId === "guidance" ? "active" : ""}`}
                              onClick={() => {
                                setActiveCourseId("guidance");
                                 
                                setIsCollapsed(true);  // navigate to guidance page
                              }}
                              tabIndex={0}
                              onKeyDown={(e) => {
                                if (e.key === "Enter" || e.key === " ") {
                                  setActiveCourseId("guidance");
                                  resetMegaMenu();
                                  setIsCollapsed(true);
                                  navigate("/contact");
                                }
                              }}
                            >
                              <i className="fa fa-comments me-1" />
                              <span>Guidance</span>
                            </div>
                          )}

                        </div>
                      )}
                    </div>
                  ))}
                  <button
                    className="btn btn-sm btn-outline-secondary mt-2"
                    onClick={handleAllCoursesClick}
                    style={{ width: "100%" }}
                  >
                    All Courses
                  </button>
                </div>
                
                {/* Right Panel */}
                <div style={{ padding: 20, background: "#fff", flex: 1, overflowY: "auto" }}>
                  {activeCourse ? (
                    activeCourse.subcourses?.length > 0 ? (
                      <div className="row g-3">
                        {activeCourse.subcourses.map((sub, idx) => (
                          <div className="col-12 col-md-6 col-lg-4" key={idx}>
                           <div 
                              className="card h-100 shadow-sm" 
                              style={{ borderRadius: 10, cursor: "pointer" }} 
                              onClick={() => {
                                navigate(`/${sub.path}`);
                                handleNavLinkClick(); // closes mega menu & sidebar
                              }}
                            >

                              <div className="card-body d-flex align-items-center gap-3">
                                {sub.icons?.endsWith(".png") ? (
                                  <img src={sub.icons.replace(/\\/g, "/")} alt={sub.name} style={{ width: 32, height: 32, objectFit: "contain", borderRadius: 4 }} />
                                ) : (
                                  <i className={`fa ${sub.icons || "fa-graduation-cap"} text-primary`} style={{ fontSize: 22 }} />
                                )}
                                <div>
                                  <h6 className="mb-0">{sub.name}</h6>
                                  {sub.duration && <small className="text-muted">{sub.duration}</small>}
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <p className="text-muted">No subcourses available for this course.</p>
                    )
                  ) : (
                    <div className="d-flex flex-column align-items-center justify-content-center h-100 text-center p-4">
                      <div style={{ maxWidth: 600 }}>
                        <img
                          src="/img/contact-nav.jpg"
                          alt="Guidance Support"
                          className="img-fluid rounded mb-4"
                          style={{ maxWidth: "100%", height: "auto" }}
                        />
                        <p className="mb-4 text-muted" style={{ fontSize: "16px" }}>
                          Unsure which course is right for you? Our experts are here to help you choose the best learning path based on your goals and experience.
                        </p>
                        <span 
                          className="btn btn-outline-primary"
                          style={{ width: "200px", height: "50px" }}
                          onClick={() => {handleContactClick();}}
                        >
                          Talk to an Expert
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
 
          <Link 
            to="/services" 
            className="nav-item nav-link"
            onClick={handleNavLinkClick}
          >
            Services
          </Link>
          <Link 
            to="/blogger" 
            className="nav-item nav-link"
            onClick={handleNavLinkClick}
          >
            Blog
          </Link>
          <Link 
            to="/contact" 
            className="nav-item nav-link"
            onClick={handleNavLinkClick}
          >
            Contact
          </Link>
          <Link 
            to="/register" 
            className="nav-item nav-link"
            onClick={handleNavLinkClick}
          >
            Register
          </Link>
          
          <Link 
            to="/login" 
            className="nav-item nav-link"
            onClick={handleNavLinkClick}
          >
            <i className="fa fa-user me-1" />
            Login
          </Link>
        </div>
      </div>
 
      <style>{`
        .course-item {
          display: flex;
          align-items: center;
          gap: 8px;
          font-size: 14px;
          font-weight: 500;
          border-radius: 6px;
          color: #495057;
          background: transparent;
          padding: 8px 10px;
          transition: all 0.2s ease;
          margin-bottom: 4px;
        }

        .course-item .course-icon {
          width: 20px;
          height: 20px;
          object-fit: contain;
          transition: all 0.2s ease;
        }
        
        .btn-light:hover,
        .btn-outline-dark:hover {
          background-color: inherit !important;
          color: inherit !important;
          box-shadow: none !important;
        }
        
        .course-item.active {
          background-color: #e9ecef !important;
          color:#495057 !important;
        }

        .course-item.active .course-icon {
          color: #495057 !important;
        }

        .card:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(113, 111, 111, 0.1) !important;
          transition: all 0.2s ease;
        }
      `}</style>
    </nav>
  );
};
 
export default Navbar;